import { LeagueSettingService } from './league-setting.service';
import { Component, Input, OnInit, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { League } from '../../../_shared/models/league.model';
import { FormControl, FormGroup } from '@angular/forms';
import { TieSelectorComponent } from '../../../ties/tie-selector/tie-selector.component';
import { Socket } from 'ngx-socket-io';
import { AuthService } from '../../../auth/auth.service';

@Component({
  standalone: false,
  selector: 'app-league-setting',
  templateUrl: './league-setting.component.html',
  styleUrls: ['./league-setting.component.scss'],
})
export class LeagueSettingComponent implements OnInit{
  @Input({ required: true }) league: League;

  private modalController = inject(ModalController);
  private leagueSettingService = inject(LeagueSettingService);
  private socket = inject(Socket);
  public authService = inject(AuthService);

  splitVideoBoardForm: FormGroup;

  ngOnInit(): void {
    this.splitVideoBoardForm = new FormGroup({
      enabled: new FormControl({ value: this.league.settings.splitVideoBoard.enabled, disabled: this.authService.authUserSignal().role.value < 400 }),
      leftSideTie: new FormControl(this.league.settings.splitVideoBoard.leftSideTie?._id),
      rightSideTie: new FormControl(this.league.settings.splitVideoBoard.rightSideTie?._id)
    })

    this.splitVideoBoardForm.get('leftSideTie').valueChanges.subscribe((_tieId) => this.updateSplitVideoBoard('LEFT', _tieId));
    this.splitVideoBoardForm.get('rightSideTie').valueChanges.subscribe((_tieId) => this.updateSplitVideoBoard('RIGHT', _tieId));
  }

  async dismiss() {
    this.modalController.dismiss();
  }

  enableDraw(ev) {
    this.leagueSettingService
      .update(this.league._id, 'draw', { enabled: ev.detail.checked })
      .subscribe({
        next: res => this.league.settings = res.data
      })
  }

  private updateSplitVideoBoard(side: string, _tieId: string) {    
    this.leagueSettingService
      .update(this.league._id, 'splitVideoBoard', this.splitVideoBoardForm.getRawValue())
      .subscribe({
        next: res => {
          this.league.settings = res.data
          this.socket.emit('split-videoboard', { 
            leagueId: this.league._id,
            config: {
              side, _tieId
            }
          });
        }

      })
  }

  async findTie(sideToUpdate: string) {
    if (!this.splitVideoBoardForm.get(sideToUpdate).value) {
      const modal = await this.modalController.create({
        component: TieSelectorComponent,
        componentProps: {
            leagueId: this.league._id
        }
      });

      await modal.present();
      const { data } = await modal.onDidDismiss();

      if (data) {
        this.splitVideoBoardForm.get(sideToUpdate).setValue(data[0]);
      }
    }
  }

  removeTie(sideToUpdate: string) {
    this.splitVideoBoardForm.get(sideToUpdate).setValue(undefined);
  }
}

